import { ComponentPropsWithoutRef } from "react";
import NodeGraphIcon from "./icons/node-graph.svg?react";
import cn from "@/helpers/classNames";

export function AgentReadyCard(props: ComponentPropsWithoutRef<"div">) {
  return (
    <div
      className={cn(
        "flex items-center gap-4 rounded-sm border border-blue-100 bg-blue-100/50 p-4 dark:border-blue-700/50 dark:bg-blue-900/20",
        props.className,
      )}
    >
      <NodeGraphIcon className="size-8 shrink-0 text-blue-600" />
      <div className="text-sm">
        <h3 className="mb-1 font-semibold">Agent-ready with Weld Connect</h3>
        <p className="text-muted-foreground">
          {props.children ?? (
            <>
              Use the Weld Connect API and MCP Server to let agents test, run,
              validate, and operate workflows across the Weld platform.
            </>
          )}
        </p>
      </div>
    </div>
  );
}

export function AgentReadyCardCompact() {
  return <AgentReadyCard className="p-2">API and MCP Server.</AgentReadyCard>;
}
